'use strict';


export const COLLECTION = 'file-fulfillments';
export const CLASS_NAME = 'FileFulfillmentDomain';

export function FileFulfillmentDomainProvider() {
  return {
    $get: [
      '$injector',
      'AbstractDomainClass',
      'OrgIdMixin',
      'ArchivableMixin',
      'FeedableMixin',
      function (
        $injector,
        AbstractDomainClass,
        OrgIdMixin,
        ArchivableMixin,
        FeedableMixin,
      ) {

        function FileFulfillmentDomain(data) {
          AbstractDomainClass.call(this, FileFulfillmentDomain, data);
        }

        AbstractDomainClass.__inheritFrom(FileFulfillmentDomain, CLASS_NAME, COLLECTION);
        OrgIdMixin(FileFulfillmentDomain);
        FeedableMixin(FileFulfillmentDomain);
        ArchivableMixin(FileFulfillmentDomain, 'FileAssetDomain', 'fileAsset', 'fulfillment');

        FileFulfillmentDomain.$constraints.addConstraints({
          requirement: {type: 'Domain', nullable: true},
          ord: {type: 'number', nullable: true},

          tsk: {type: 'string', nullable: true}, /* Optional parent task id */
          aTk: {type: 'string', nullable: true}, /* Optional parent asset task id */
          org: {type: 'string'}, // Organization ID
          createdBy: {type: 'DomainLink', domainClass: 'UserDomain'},
          dateCreated: {type: 'Date'},
          lastUpdated: {type: 'Date'}
        });

        //prototype methods go here

        FileFulfillmentDomain.prototype.$generateFileRequest = function $generateFileRequest(requirement) {
          //TODO(files): verify that the missing bucket is handled server side correctly
          return {
            path: `${requirement.$getPath()}/${this.$id}`,
            firebasePath: `${requirement.$getCollectionPath()}/${this.$class.COLLECTION}`,
            filename: requirement.$getName()
          };
        };

        FileFulfillmentDomain.prototype.toString = function () {
          return this.dateCreated + (this.currentFileAsset ? ' - ' + this.currentFileAsset.status : '');
        };

        return FileFulfillmentDomain;
      }]
  };
}



// WEBPACK FOOTER //
// ./src/js/requirements/domain/files/FileFulfillmentDomain.js